import * as React from 'react';
import { useAppDispatch } from '../../hooks';
import { ServiceCards } from '../../components/ServiceCards';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { openHomeProfileOnboardingModal, openNewDreamOnboardingModal } from '../../slices';
import { trackHomeProfitClick, trackNewDreamClick } from './tracking';

export const ServiceCardsContainer: React.FC = () => {
  const isDesktop = useIsDesktop();
  const dispatch = useAppDispatch();

  const handleNewDreamClick = React.useCallback(() => {
    dispatch(openNewDreamOnboardingModal(true));
    trackNewDreamClick();
  }, [dispatch]);

  const handleHomeProfitClick = React.useCallback(() => {
    dispatch(openHomeProfileOnboardingModal(true));
    trackHomeProfitClick();
  }, [dispatch]);

  return (
    <ServiceCards
      isDesktop={isDesktop}
      newDreamOnClick={handleNewDreamClick}
      homeProfitOnClick={handleHomeProfitClick}
    />
  );
};
